import { UAParser } from 'ua-parser-js';

export function getErrorMessage(err) {
  var errorMessage,
    helpMessage = '';
  let audioPermissions, videoPermissions;
  switch (err.msg) {
  case 'AbortError':
    errorMessage = 'We\'re unable to connect you!';
    helpMessage = 'Please try reloading the page.';
    break;
  case 'NotAllowedError':
    navigator.mediaDevices
      .getUserMedia({
        audio: true,
      })
      .then(() => (audioPermissions = true))
      .catch(() => {
        audioPermissions = false;
        errorMessage = 'Microphone permission denied.';
      });

    navigator.mediaDevices
      .getUserMedia({
        video: true,
      })
      .then(() => (videoPermissions = true))
      .catch(() => {
        videoPermissions = false;
        if (!audioPermissions && !videoPermissions) {
          errorMessage = 'Camera and Microphone permissions denied.';
        } else if (!videoPermissions) {
          errorMessage = 'Camera permission denied.';
        }
      });
    errorMessage = 'Camera (and/or) Microphone permissions denied.';
    helpMessage =
        'Please click the lock icon in the address bar on your browser and select allow for camera and microphone permissions.';
    break;
  case 'NotReadableError':
    errorMessage = 'Faulty camera or microphone.';
    helpMessage =
        'We\'ve encountered a problem with your camera or microphone. Please try switching to another camera or microphone.';
    break;
  case 'OverconstrainedError':
    errorMessage =
        err.constraint || 'Unable to connect to your camera and microphone!';
    helpMessage =
        err.message ||
        'We\'ve encountered a problem connecting with your camera or microphone. Please try reloading the page and switching to another camera or microphone.';
    break;
  default:
    errorMessage = 'Unable to connect to your camera and microphone!';
    helpMessage =
        'We\'ve encountered a problem connecting with your camera or microphone. Please try reloading the page and switching to another camera or microphone.';
  }
  return { errorMessage, helpMessage };
  // errorWrapper.innerHTML = "";
  // errorWrapper.appendChild(errorMessage);
  // errorWrapper.appendChild(helpMessage);
}

export class BrowserOSChecker {
  constructor() {
    let parser = new UAParser();
    this.browser = parser.getBrowser();
    this.os = parser.getOS();
    this.result = parser.getResult();

    this.chrome_icon = '<img  height="25px" src="data:image/svg+xml;base64,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" />';
    let playstore_icon = '<img height="25px" src="https://img.icons8.com/color/452/google-play.png"/>';

    this.chrome_help_links = `
      <div class="row justify-content-center align-items-center mt-3 d-lg-none">
        <div class="col-xs-6">
          <a href="googlechrome://navigate?url=${location.href}" class="btn btn-primary text-center">Use Chrome ${this.chrome_icon}</a>
        </div>
        <div class="col-xs-6">
          <a href="https://play.google.com/store/apps/details?id=com.android.chrome" class="btn btn-outline-primary ml-3 text-center">${playstore_icon} Install Chrome</a>
        </div>
      </div>
    `;
  }

  userAgent() {
    var result = this.result;
    let ua = result && result.ua;
    return ua;
  }

  browserOSVersions() {
    return { os: this.os, browser: this.browser };
  }

  testOS() {
    var os = this.os;
    var result = this.result;
    let ua = result && result.ua;

    os.version = parseFloat(os.version);
    if (
      ua == 'gumstack:android' ||
      ua == 'gumstack:ios' ||
      ua == 'gumstack:embed:ios' ||
      ua == 'gumstack:embed:android' ||
      (os.name == 'Windows' && os.version >= 7) ||
      (os.name == 'Mac OS' && os.version >= 10) ||
      (os.name == 'Android' && os.version >= 5) ||
      (os.name == 'iOS' && os.version >= 11) ||
      os.name == 'Linux'
    ) {
      return { isCompatible: true };
    } else {
      return {
        isCompatible: false,
        message:
          'Your device OS is not compatible to join the session. Please use Windows 7+, Mac OS 10+, Android 5+ or iOS 11+.',
      };
    }
  }

  compatibilityTest() {
    var os = this.os;
    var browser = this.browser;
    var result = this.result;
    let ua = result && result.ua;
    browser.version = parseFloat(browser.version);
    os.version = parseFloat(os.version);
    let passedOS = this.testOS();
    if (ua.match(/gumstack:ios|gumstack:android/g)) {
      console.log('[GUMSTACK APP] ua check passed');
      return {
        isCompatible: true,
      };
    }

    if (passedOS.isCompatible) {
      switch (os.name) {
      case 'Windows':
      case 'Linux':
      case 'Mac OS':
        if (
          (browser.name == 'Chrome' && browser.version >= 58) ||
            (browser.name == 'Firefox' && browser.version >= 56) ||
            (browser.name == 'Edge' && browser.version >= 80) ||
            (browser.name == 'Opera' && browser.version >= 45) ||
            (os.name == 'Mac OS' &&
              browser.name == 'Safari' &&
              browser.version >= 11)
        ) {
          return {
            isCompatible: true,
          };
        } else {
          return {
            isCompatible: false,
            message: `${browser.name} does not support video/audio calling on ${os.name}. Please use Google Chrome on ${os.name} to join this call.`,
          };
        }
      case 'Android':
        if (
          (browser.name == 'Chrome' && browser.version >= 58) ||
            browser.name == 'Edge' ||
            browser.name == 'Chrome WebView' ||
            browser.name == 'Firefox' ||
            ua == 'gumstack:android' ||
            ua == 'gumstack:embed:android'
        ) {
          return {
            isCompatible: true,
          };
        } else {
          return {
            isCompatible: false,
            message: `${browser.name} does not support video/audio calling on ${os.name}. Please use Google Chrome on ${os.name} to join this call.`,
          };
        }
      case 'iOS':
        if (
          ((browser.name == 'Mobile Safari' || browser.name == 'Safari') &&
              browser.version >= 11) ||
            (browser.name == 'Chrome' && os.version > 14.4) ||
            browser.name == 'WebKit' ||
            (browser.name == 'GSA' && os.version > 14.4) ||
            (browser.name == 'CriOS' && os.version > 14.4) ||
            ua == 'gumstack:ios' ||
            ua == 'gumstack:embed:ios'
        ) {
          return {
            isCompatible: true,
          };
        } else {
          return {
            isCompatible: false,
            message: `${browser.name} does not support video/audio calling on ${os.name}. Please use Safari 11+ for iOS.`,
          };
        }
      }
    } else {
      return passedOS;
    }
  }
}
